module.exports = __webpack_public_path__ + "static/media/MachineIntelligenceLogo.ea20ef7d.png";